import { form } from '../../formState'

import { useShowPhoneAlert } from '../../hooks/useShowPhoneAlert'
import { useAutomatedMessageValidation } from './hooks/useAutomatedMessageValidation'
import { useTexts } from './hooks/useTexts'

export function AutomatedMessageField() {
  const texts = useTexts()
  const validateAutomatedMessage = useAutomatedMessageValidation()
  const showPhoneAlert = useShowPhoneAlert()
  const status = form.useFormField('status')
  const callbackConfigStatus = form.useFormField('callbackConfigStatus')
  const automatedMessageEnabled = form.useFormField('automatedMessageEnabled')

  form.useAddFieldValidation<'automatedMessage'>(
    'automatedMessage',
    async (field, _formApi) => {
      const automatedMessageValidation = await validateAutomatedMessage(
        field.value,
        automatedMessageEnabled.field.value,
        status.field.value,
        callbackConfigStatus.field.value,
      )

      return automatedMessageValidation.automatedMessageError?.message
    },
    { customUID: 'automatedMessage' },
  )

  return (
    <form.TextField
      testId="voice-automated-message"
      label={texts.automatedMessage.label}
      placeholder={texts.automatedMessage.placeholder}
      helperText={showPhoneAlert && texts.automatedMessage.helpertext}
      textfieldProps={{
        multiline: true,
        rows: 3,
      }}
      name="automatedMessage"
      validateOn="blur change"
    />
  )
}
